import { Download, Trash2, Volume2, Cpu, Image as ImageIcon, Calendar, Copy, Check, ChevronRight } from 'lucide-react'
import { apiClient } from '../../utils/api'
import type { HistoryItem } from '../../hooks/useHistoryData'

interface HistoryListViewProps {
  history: HistoryItem[]
  copiedId: string | null
  onDownload: (id: string) => void
  onDelete: (id: string) => void
  onCopyPrompt: (id: string, prompt: string) => void
}

export function HistoryListView({ history, copiedId, onDownload, onDelete, onCopyPrompt }: HistoryListViewProps) {
  return (
    <div className="space-y-3 mb-8">
      {history.map((item) => (
        <div key={item.id} className="bg-[#161b22] rounded-lg border border-cyan-900/30 hover:border-cyan-500/50 transition-colors p-4 group">
          <div className="flex items-start justify-between gap-4">
            {/* Content */}
            <div className="flex-1 min-w-0">
              <div className="flex items-start gap-3 mb-3">
                <p className="text-sm text-gray-300 flex-1" title={item.prompt}>
                  {item.prompt}
                </p>
                <button
                  onClick={() => onCopyPrompt(item.id, item.prompt)}
                  className="flex-shrink-0 p-1.5 rounded-md hover:bg-white/10 transition-colors group/copy"
                  title="复制提示词"
                >
                  {copiedId === item.id ? (
                    <Check className="w-4 h-4 text-green-400" />
                  ) : (
                    <Copy className="w-4 h-4 text-gray-400 group-hover/copy:text-white" />
                  )}
                </button>
              </div>

              <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-gray-500">
                <div className="flex items-center space-x-1">
                  {item.media_type === 'image' ? (
                    <><Cpu className="w-3.5 h-3.5" /><span>图像生成</span></>
                  ) : item.media_type === 'vision' ? (
                    <><ImageIcon className="w-3.5 h-3.5" /><span>图像理解</span></>
                  ) : (
                    <><Volume2 className="w-3.5 h-3.5" /><span>语音生成</span></>
                  )}
                </div>
                <div className="flex items-center space-x-1">
                  <Cpu className="w-3.5 h-3.5" />
                  <span>{item.model_used.split('/').pop()?.split(':')[0] || 'Unknown'}</span>
                </div>
                <div className="flex items-center space-x-1">
                  <Calendar className="w-3.5 h-3.5" />
                  <span>{new Date(item.created_at).toLocaleString()}</span>
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="flex items-center space-x-2 flex-shrink-0">
              {item.media_type === 'audio' && (
                <button
                  onClick={() => window.open(apiClient.getImageUrl(item.id), '_blank')}
                  className="flex items-center space-x-1.5 px-3 py-2 bg-cyan-900/20 hover:bg-cyan-900/30 rounded-lg transition-colors text-sm"
                >
                  <ChevronRight className="w-4 h-4" />
                  <span>播放</span>
                </button>
              )}
              <button
                onClick={() => onDownload(item.id)}
                className="p-2 bg-cyan-900/20 hover:bg-cyan-900/30 rounded-lg transition-colors"
                title="下载"
              >
                <Download className="w-4 h-4" />
              </button>
              <button
                onClick={() => onDelete(item.id)}
                className="p-2 bg-red-500/20 hover:bg-red-500/30 text-red-400 rounded-lg transition-colors"
                title="删除"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
